import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { fontStyles } from "../../../../Component/style/admin_font";
import {
  CenterView,
  AdminIcon as Icon,
  RowView2,
  TitleArea,
} from "../../../../Component/style/common_style";

const Product_list = ({
  visible, handleModal, list, selectedItems, setSearch_item, loading, error,
}: modalProps & {
  list: string[];
  selectedItems: string[];
  setSearch_item: React.Dispatch<React.SetStateAction<string[]>>;
  loading: boolean;
  error: string;
}) => {
  const [search_word, setSearch_word] = useState("");
  const [search_value, setSearch_value] = useState("");
  useEffect(() => { if (visible) { setSearch_word(""); setSearch_value(""); } }, [visible]);
  const viewList = list.filter(name => name.toLocaleLowerCase().includes(search_value.toLocaleLowerCase()));
  const toggle = (name: string) => setSearch_item(items =>
    items.includes(name) ? items.filter(item => item !== name) : [...items, name]);
  const search = () => setSearch_value(search_word.trim());
  const allVisibleSelected = viewList.length > 0 && selectedItems.length === viewList.length
    && viewList.every(name => selectedItems.includes(name));
  const reset = () => { setSearch_word(""); setSearch_value(""); };

  if (!visible) return null;
  return (
    <ModalBox className="col" role="dialog" aria-label="품목 선택">
      <TitleArea style={{ width: "100%", padding: "1rem" }}>
        <div>품목 선택</div>
        <ModalCloseButton tone="admin" aria-label="품목 선택 닫기" onClick={handleModal} />
      </TitleArea>
      <Row as="label">
        <span className="idx"><input type="checkbox" aria-label="검색 결과 전체 선택"
          checked={allVisibleSelected} disabled={loading || !!error || viewList.length === 0}
          onChange={event => setSearch_item(event.target.checked ? [...viewList] : [])} /></span>
        <span className="name">검색 결과 전체 선택 ({viewList.length}개)</span>
      </Row>
      <Header>
        <div className="idx">선택</div>
        <div className="name">품목명</div>
      </Header>
      <ScrollBox aria-busy={loading}>
        {error ? <p role="alert">{error}</p> : viewList.map(name => (
          <Row as="label" key={name}>
            <span className="idx">
              <input type="checkbox" checked={selectedItems.includes(name)} onChange={() => toggle(name)} />
            </span>
            <span className="name">{name}</span>
          </Row>
        ))}
        {!error && loading && <p role="status">품목을 불러오는 중입니다.</p>}
        {!error && !loading && viewList.length === 0 && <p role="status">해당 주문 내역에 품목이 없습니다.</p>}
      </ScrollBox>
      <SearchArea data-admin-search="">
        <input placeholder="품목검색" aria-label="품목검색" value={search_word}
          onChange={event => setSearch_word(event.target.value)}
          onKeyDown={event => { if (event.key === "Enter" && !event.nativeEvent.isComposing) search(); }} />
        <CenterView as="button" type="button" data-admin-search-action="" className="btn" onClick={search}>검색</CenterView>
        <CenterView as="button" type="button" data-admin-search-reset="" className="reset" aria-label="품목 검색 초기화" onClick={reset}>
          <Icon src={require("../../../../Image/ic_reset_black.png")} alt="" />
        </CenterView>
      </SearchArea>
    </ModalBox>
  );
};

export default Product_list;

const ModalBox = styled(CenterView)`
  position: absolute;
  top: 0;
  margin-top: 1.5rem;
  box-sizing: border-box;
  width: min(30rem, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  overflow-x: hidden;
  border: 1px solid var(--admin-theme-border, #e8e8e8);
`;
const Header = styled(RowView2)`
  width: 100%;
  color: var(--admin-theme-muted, #757575);
  background-color: var(--admin-theme-raised, #f8f8f8);
  border: 1px solid var(--admin-theme-border, #e8e8e8);
  div.idx {
    box-sizing: border-box;
    padding: 1rem 0;
    text-align: center;
    width: 3rem;
    border-right: 1px solid var(--admin-theme-border, #e8e8e8);
  }
  div.name {
    padding: 1rem;
    flex: 1;
  }
`;
const ScrollBox = styled.div`
  width: 100%;
  height: 20rem;
  overflow-y: auto;
  overflow-x: hidden;
`;
const Row = styled(RowView2)`
  width: 100%;
  min-height: 44px;
  .idx input { flex: none; padding: 0; margin: 0; min-width: 18px; width: 18px; height: 18px; accent-color: var(--admin-accent); cursor: pointer; }
  input:focus-visible { outline: 2px solid var(--admin-accent); outline-offset: 2px; }
  border-top: 1px solid var(--admin-theme-border, #e8e8e8);
  cursor: pointer;
  span.idx {
    box-sizing: border-box;
    padding: 0.5rem 0;
    text-align: center;
    width: 3rem;
    border-right: 1px solid var(--admin-theme-border, #e8e8e8);
  }
  span.name {
    padding: 0.5rem 1rem;
    flex: 1;
  }
  &:hover {
    background-color: var(--admin-theme-surface, #fafafa);
  }
`;
const SearchArea = styled(RowView2)`
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  border-top: 1px solid var(--admin-theme-border, #e8e8e8);
  button { min-height: 44px; border: 0; font: inherit; }
  button.btn { padding: 0 16px; }
  button.reset { margin-left: 8px; padding: 8px; border-radius: 8px; background: transparent; cursor: pointer; }
  button.reset img { width: 24px; height: 24px; }
  button:focus-visible { outline: 2px solid var(--admin-accent); outline-offset: 2px; }
  button.btn {
    margin-left: 0.5rem;
    border: 0;
    ${fontStyles.medium};
    text-align: center;
    color: white;
    background-color: var(--admin-solid, #292433);
    border-radius: 8px;
    cursor: pointer;
  }
`;
